/*
 * Based on https://github.com/Swizec/useDimensions
 */
import { useState, useCallback, useLayoutEffect } from 'react';

export interface DimensionObject {
  width: number;
  height: number;
  top: number;
  left: number;
  x: number;
  y: number;
  right: number;
  bottom: number;
}

export type UseDimensionsHook = [
  (node: HTMLElement) => void,
  DimensionObject,
  HTMLElement,
];

export interface UseDimensionsArgs {
  liveMeasure?: boolean;
}

const useDimensions = ({
  liveMeasure = true,
}: UseDimensionsArgs = {}): UseDimensionsHook => {
  const [dimensions, setDimensions] = useState(null as DimensionObject);
  const [node, setNode] = useState(null);

  const ref = useCallback((aNode) => {
    setNode(aNode);
  }, []);

  useLayoutEffect((): void => {
    if (node) {
      const measure = (): void => {
        window.requestAnimationFrame(() => setDimensions(node.getBoundingClientRect()));
      };
      measure();

      if (liveMeasure) {
        window.addEventListener('resize', measure);
        window.addEventListener('scroll', measure);
      }
    }
  }, [node, liveMeasure]);

  return [ref, dimensions, node];
};

export default useDimensions;
